import { Modal, useModals } from 'almanac-ui/Modal'
import Styles from './Success.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { Button } from 'blaze-ui/Button'
import { useRootStore } from 'stores/RootStore'
export const Success = () => {
  const { closeModal } = useModals()
  const { drawersStore } = useRootStore()

  const handleClose = () => {
    closeModal()
    drawersStore.closeDrawer()
  }

  return (
    <>
      <Modal.Header title="You're a Pro!" preventClose />
      <Modal.Content>
        <div className={Styles.body}>
          <iframe
            width="100%"
            className={Styles.video}
            height="292px"
            src="https://www.youtube.com/embed/usLl8CLlXRY?si=ajLJdJDwLvS_sh51"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            frameBorder="0"
          ></iframe>
          <Text variant="primary">
            With your upgraded access, you now have powerful features designed to help you work smarter, faster, and
            more efficiently.
          </Text>
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Button variant="tertiary" size="lg" onPress={handleClose}>
            Close
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Button size="lg" onPress={handleClose}>
            Done
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </>
  )
}
